import dayjs, { Dayjs } from 'dayjs'

export function isDayjs (value: unknown): value is Dayjs {
  return (dayjs as any)?.isDayjs ? (dayjs as any).isDayjs(value) : false
}

// Parse ISO-like strings that might contain microseconds (6 fractional digits) by
// normalizing fractional seconds to milliseconds before handing to dayjs.
export function parseISOToDayjs (value: unknown): Dayjs | null {
  if (value == null) return null
  if (isDayjs(value)) return value
  if (value instanceof Date) {
    const parsedDate = dayjs(value)
    return parsedDate.isValid() ? parsedDate : null
  }
  const s = String(value)
  let parsed = dayjs(s)
  if (parsed.isValid()) return parsed

  // Trim fractional seconds to milliseconds: .000000Z -> .000Z
  const normalized = s.replace(/\.(\d{3})\d+(?=Z|[+-]|$)/, '.$1')
  parsed = dayjs(normalized)
  return parsed.isValid() ? parsed : null
}

export function dayjsToISOString (value: Dayjs | null): string | null {
  if (!value) return null
  return value.toISOString()
}
